export default "__VITE_ASSET__lNz_AVUD__"